// Moved to @hyperframes/parsers. Re-exported here for back-compat.
export {
  FONT_ALIAS_MAP,
  FONT_ALIAS_KEYS,
  CANONICAL_FONT_DISPLAY_NAMES,
  resolveAliasDisplayName,
} from "@hyperframes/parsers";
